import callApi from '../../util/apiCaller';

// Export Constants
export const ADD_NEWS = 'ADD_NEWS';
export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS';
// Export Actions

export function fetchNews() {
  return (dispatch) => {
    dispatch({
      type: ADD_NEWS, news: [], status: 'loading', errors: null,
    });
    return callApi('news', 'GET', { is_visible: true }).then(
      res => dispatch({
        type: ADD_NEWS, news: res.news, status: 'loaded', errors: null,
      }),
      errors => dispatch({
        type: ADD_NEWS, news: [], status: 'error', errors,
      }),
    );
  };
}

export function resetNotifications() {
  return dispatch => callApi('news/notifications', 'DELETE').then(
    () => dispatch({
      type: UPDATE_NOTIFICATIONS, count: 0,
    }),
    () => dispatch({
      type: UPDATE_NOTIFICATIONS, count: 0,
    }),
  );
}

export function updateNotifications() {
  return dispatch => callApi('news/notifications', 'GET').then(
    res => dispatch({
      type: UPDATE_NOTIFICATIONS, count: res.count,
    }),
    () => dispatch({
      type: UPDATE_NOTIFICATIONS, count: 0,
    }),
  );
}
